import getConfig from "next/config";
import { LeaflyEnv } from "@leafly-com/lm-config";

const { publicRuntimeConfig } = getConfig();
export const isLocalDev = () => publicRuntimeConfig.env === LeaflyEnv.LocalDev;
